import { memo } from '../../../utils/memo.mjs';
var supportsScrollTimeline = memo(function () {
  return window.ScrollTimeline !== undefined;
});
export { supportsScrollTimeline };